const LAST_ACTIVITY_KEY = 'lastActivityAt';

export const markLastActivity = () => window.sessionStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());

export const getLastActivity = (): number | null => {
    const stored = window.sessionStorage.getItem(LAST_ACTIVITY_KEY);
    return stored ? Number(stored) : null;
};

export const clearLastActivity = () => window.sessionStorage.removeItem(LAST_ACTIVITY_KEY);
